import React, {useEffect, useMemo, useState} from "react";
import { Link } from "react-router-dom";
import * as Constants from "./../../constants";
import Button from "../../components/reusableElementsComponents/Button";
import { InputAdornment } from "@mui/material";
import {toast, ToastContainer} from "react-toastify";
import { FormControl, TextField } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import TalentsApiService from "../../TalentsApiService";
import Loading from "../../components/reusableElementsComponents/Loading";
import { t } from "../../content";
import { useLocale } from "../../locale";
import AuthPageChrome from "../../components/layoutComponents/authComponents/AuthPageChrome";

function SetPassword() {
  const { withLocale } = useLocale();
  const api = useMemo(() => {
    return new TalentsApiService();
  }, []);
  const [count, setCount] = useState(0);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState(false);
  const [token, setToken] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [isKeyValid, setIsKeyValid] = useState(false);

  useEffect(() => {
    if (count < 3) {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count, isKeyValid]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const accessToken = query.get("key");
    api.ValidateResetPasswordKey({ key: accessToken}).then((response) => {
      if (response.httpStatus === 200) {
        if(response.json?.status){
          setToken(accessToken);
          setIsKeyValid(true)
        }
      }
    });
  }, [api]);

  useEffect(() => {
    if (password.length !== 0) {
      if (password === confirmPassword) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      setDisabled(true);
    }
  }, [password, confirmPassword]);

  const handleBlur = () => {
    let valid = Constants.VALID_PASSWORD.test(password);
    if (valid) {
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    const passwordResetEmailSent = toast.loading(
        t('auth.toasts.resettingPassword'),
        {containerId: 'reset-password'}
    );
    api.SetNewPassword({ key: token, password: password }).then((response) => {
      if (response.httpStatus === 200) {
        setSubmitting(true);
        toast.update(passwordResetEmailSent, {
          render: t('auth.toasts.passwordUpdated'),
          type: "success",
          isLoading: false,
          autoClose: '2000',
          closeButton: true,
          hideProgressBar: true
        });
        setTimeout(() => {
            window.location.href = withLocale('/login')
        }, 2000)
      } else {
        toast.update(passwordResetEmailSent, {
          render: t('auth.toasts.unableToReset'),
          type: "error",
          isLoading: false,
          autoClose: '2000',
          closeButton: true,
          hideProgressBar: true
        });
      }
    });
  };

  if (count < 3) {
    return <Loading />;
  }

  return (
    <div className="auth-page-wrapper">
      <AuthPageChrome />
      <div className="form-wrapper">
        {!isKeyValid && (
            <>
              <h3 className="title semi-bold">{t('auth.setPassword.invalidLink')}</h3>
              <Link className="back-to-login-link bold reg-as-talent regular" to={withLocale('/recover-password')}>
                <p className={`m-0 light ${submitting ? "bold text-center" : ""}`}>
                  {'<< '}{t('auth.setPassword.requestNewLink')}
                </p>
              </Link>
            </>
        )}
        {isKeyValid && (<Link className="back-to-login-link reg-as-talent regular" to={withLocale('/login')}>
          <p className={`m-0 light ${submitting ? "bold text-center" : ""}`}>
            {'<< '}{t('auth.recover.backToLogin')}
          </p>
        </Link>)}
        <br/>
        <ToastContainer containerId="reset-password"/>
        {isKeyValid && (<div className="section" style={{"display": `${submitting ? "none" : ""}`}}>
          <h3 className="title semi-bold">
            {t('auth.setPassword.title')}
          </h3>
          <form className="form" onSubmit={handleSubmit}>
            <FormControl fullWidth>
              <TextField
                  placeholder={t('common.placeholders.enterNewPassword')}
                  id="password"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  autoComplete="on"
                  value={password}
                  onBlur={handleBlur}
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <button type="button" onClick={() => setPasswordVisible(!passwordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                              {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          </button>
                        </InputAdornment>
                    ),
                  }}
                  variant="standard"
                  onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            {error &&
                <div>
                    <p style={{ color: "red" }}>{t('validation.passwordInstruction')}</p>
                </div>
            }
            <FormControl fullWidth>
              <br/>
              <TextField
                  placeholder={t('common.placeholders.confirmPassword')}
                  id="passwordconfirmation"
                  name="password"
                  type={confirmPasswordVisible ? "text" : "password"}
                  autoComplete="on"
                  value={confirmPassword}
                  onBlur={handleBlur}
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <button type="button" onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                              {confirmPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          </button>
                        </InputAdornment>
                    ),
                  }}
                  variant="standard"
                  onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </FormControl>
            {disabled && confirmPassword.length !== 0 && (
                <div>
                  <p style={{color: "red"}}>{t('auth.setPassword.bothMustMatch')}</p>
                </div>
            )}

            <div className="authButtons">
              <Button
                  btnstyle={
                    disabled ? "mazhrBtn default" : "mazhrBtn default-green"
                  }
                  onClick={handleSubmit}
                  disabled={disabled}
              >
                {t('auth.setPassword.reset')}
              </Button>
            </div>
          </form>
        </div>)}
      </div>
    </div>
  );
}

export default SetPassword;
